import React from "react";
import RichText from "components/rich-text";
import Link from "components/link";
import clsx from "clsx/lite";
import Form from "../form";

const OverlayLayout = ({ data }) => {
	const { title, subtitle, showLoginOption, leftContent, layout, tag } = data;

	return (
		<div className="w-full flex justify-center items-center">
			<div className={data.leftContent ? "lg:max-w-4xl w-full lg:py-20" : "py-10 max-w-2xl"}>
				<div className="flex flex-col bg-[#000000b3] backdrop-blur-md">
					<div className="flex w-full">
						{leftContent &&
							<div className=" text-white p-10 hidden lg:flex w-1/2">
								<RichText data={{ content: leftContent }} />
							</div>
						}
						<div className="bg-white sm:hidden">
							<div className="p-16 bg-black">
								<h1 className="text-center text-white">MOD PRO Trade Program</h1>
								<h4 className="text-center text-white pt-4">
									Members enjoy up to 25% off consumer prices
								</h4>
								<div className="flex w-full justify-center pt-10">
									<a href="#modProSignup" className="btn-secondary w-full text-center">Join Free</a>
								</div>
							</div>
							<div className="p-6 flex backdrop-blur-md w-full ">
								<RichText data={{ content: data.mobileContent }} />
							</div>
						</div>
						<div className=
							"hidden lg:flex pb-4 px-10 flex-col items-center lg:bg-white text-white lg:text-black w-full lg:w-1/2 pt-14">
							<div className="max-w-md">
								{title && <h4>{title}</h4>}
								{subtitle && <h5 className="pt-3">{subtitle}</h5>}
								<Form layout={layout} tag={tag} />
							</div>
						</div>
					</div>
					<div className={clsx(
						"w-full py-4 justify-center text-center flex-col bg-black bg-opacity-70",
						"hidden sm:flex backdrop-blur-md pb-10 lg:pb-4 lg:bg-black text-white")}
					>
						{showLoginOption &&
							<p className="uppercase">
								Already a pro?
								<Link to="/account/login" className="ml-1 underline t-already-pro">
									Log in here
								</Link>
							</p>
						}
						<RichText data={{ content: data.footerText }} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default OverlayLayout;